import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import {
  settingsApi,
  PaymentMethodFlags,
} from '@/apis/settings';
import { QUERY_KEYS } from '@/constants';

export const settingKeys = {
  paymentMethods: () => [QUERY_KEYS.SETTINGS, 'payment-methods'] as const,
};

export const usePaymentMethodFlags = () =>
  useQuery({
    queryKey: settingKeys.paymentMethods(),
    queryFn: settingsApi.getPaymentMethods,
  });

export const useUpdatePaymentMethods = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (update: Partial<PaymentMethodFlags>) =>
      settingsApi.updatePaymentMethods(update),
    onSuccess: (data) => {
      queryClient.setQueryData(settingKeys.paymentMethods(), data);
      toast.success('Payment methods updated');
    },
    onError: () => {
      toast.error('Failed to update payment methods');
    },
  });
};
